export { SysqueDatagridSizeRangeModule } from './sysque-datagrid-size-range.module';
export { SysqueDatagridSizeRangeComponent } from './sysque-datagrid-size-range.component';